export const GET_SALES_REQUEST  = 'COMMISSIONS/GET_SALES_REQUEST';
export const GET_SALES_SUCCESS  = 'COMMISSIONS/GET_SALES_SUCCESS';
export const GET_SALES_ERROR    = 'COMMISSIONS/GET_SALES_ERROR';
